import { useState } from "react";
import { clearStore } from "utils/redux.utils";

export const useLocalStorage = (keyName: string, defaultValue: any) => {
  const [storedValue, setStoredValue] = useState(() => {
    try {
      const value = window.sessionStorage.getItem(keyName);

      if (value) {
        const isJson = isJsonString(value);
        if (isJson) {
          return JSON.parse(value);
        }
        return value;
      } else {
        // window.sessionStorage.setItem(keyName, JSON.stringify(defaultValue));
        clearStore();
        return defaultValue;
      }
    } catch (err) {
      return defaultValue;
    }
  });

  const setValue = (newValue: any) => {
    try {
      window.sessionStorage.setItem(keyName, JSON.stringify(newValue));
    } catch (err) {}
    setStoredValue(newValue);
  };

  return [storedValue, setValue];
};

function isJsonString(str: string) {
  try {
    JSON.parse(str);
  } catch (e) {
    return false;
  }
  return true;
}
